import React, { useState } from 'react';

const BetaCodeModal = ({ onSubmit, onClose, onWaitlistClick, errorMessage }) => {
  const [code, setCode] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(code);
  };

  return (
    <div className="bg-white shadow-md rounded-lg px-8 pt-6 pb-8 max-w-md mx-auto">
      <h2 className="text-3xl font-bold mb-4 text-center">Got an invite?</h2>
      <p className="text-gray-600 mb-6 text-center">
        Paribus AI is currently in private beta. If you have an invite code, please enter it below for instant access. Otherwise, please{' '}
        <button
          onClick={onWaitlistClick}
          className="text-blue-500 hover:underline"
        >
          sign up for our waitlist
        </button>
        .
      </p>
      <form onSubmit={handleSubmit}>
        <input
          type="text"
          value={code}
          onChange={(e) => setCode(e.target.value)}
          className="shadow appearance-none border rounded-lg w-full py-3 px-4 text-gray-700 leading-tight focus:outline-none focus:shadow-outline mb-4"
          placeholder="Invite code"
        />
        {errorMessage && (
          <p className="text-red-500 text-sm mb-4">{errorMessage}</p>
        )}
        <button
          type="submit"
          className="bg-blue-500 hover:bg-blue-600 text-white font-bold py-3 px-4 rounded-lg w-full focus:outline-none focus:shadow-outline mb-4"
        >
          Unlock access
        </button>
      </form>
      <button
        onClick={onClose}
        className="text-gray-500 hover:text-gray-700 w-full text-center"
      >
        Cancel
      </button>
    </div>
  );
};

export default BetaCodeModal;
